export default "__VITE_ASSET__LTtGqXH0__"